function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGear = function SvgGear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 2c0-1.1-.9-2-2-2S8 .9 8 2v.9c0 .2-.1.4-.4.5l-.6.3c-.2.1-.4 0-.6-.1l-.6-.7c-.8-.8-2-.8-2.8 0s-.8 2 0 2.8l.6.6c.1.3.2.5.1.7l-.3.6c-.1.3-.3.4-.5.4H2c-1.1 0-2 .9-2 2s.9 2 2 2h.9c.2 0 .4.1.5.4l.3.6c.1.2.1.4-.1.6l-.6.6c-.8.8-.8 2 0 2.8.8.8 2 .8 2.8 0l.6-.6c.2-.2.4-.2.6-.1l.6.3c.3.1.4.3.4.5v.9c0 1.1.9 2 2 2s2-.9 2-2v-.9c0-.2.1-.4.4-.5l.6-.3c.2-.1.4-.1.6.1l.6.6c.8.8 2 .8 2.8 0 .8-.8.8-2 0-2.8l-.6-.6c-.2-.2-.2-.4-.1-.6l.3-.6c.1-.2.3-.4.5-.4h.9c1.1 0 2-.9 2-2s-.9-2-2-2h-.9c-.2 0-.4-.1-.5-.4l-.3-.6c-.1-.2-.1-.4.1-.6l.6-.6c.8-.8.8-2 0-2.8-.8-.8-2-.8-2.8 0l-.6.6c-.2.2-.4.2-.6.1l-.6-.3c-.3-.1-.4-.3-.4-.5V2zm-2 11c1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3 1.3 3 3 3z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgGear;